import { axiosClient } from '@/shared/apis/config';
import { ApiResponse } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import { GtsGalleryVideoItem } from '../model/gts-types';

export const QueryKeyGetGtsVideos = 'gts-videos';

// contentData.videos에서 영상 목록 조회
export type GetGtsVideosResponse = ApiResponse<GtsGalleryVideoItem[]>;

export const getGtsVideosApi = async (
  projectId: number,
  status?: 'PROCESSING',
  contentIds?: number[],
  parentId?: number,
): Promise<GetGtsVideosResponse> => {
  try {
    const params: Record<string, any> = {};
    if (status) {
      params.status = 'PROCESSING';
    }
    if (contentIds && contentIds.length > 0) {
      params.contentIds = contentIds;
    }
    if (parentId) {
      params.parentId = parentId;
    }

    const response = await axiosClient.get<GetGtsVideosResponse>(
      `/v1.0/project/${projectId}/gts/videos`,
      {
        params: Object.keys(params).length > 0 ? params : undefined,
      },
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useGetGtsVideos = (
  projectId: number | null,
  status?: 'PROCESSING',
  contentIds?: number[],
  parentId?: number,
) => {
  return useQuery({
    queryKey: [QueryKeyGetGtsVideos, projectId, status, contentIds, parentId],
    queryFn: () => getGtsVideosApi(projectId!, status, contentIds, parentId),
    enabled: projectId !== null,
  });
};
